// The platform's grid runtime for the shared file-import views
// (@twasta/page-runtime/txn/capture ImportPreview / ImportActionWindow): the
// designer capture runtime in 'customize' layout mode — a column tweak made
// while reviewing an import is a per-tenant overlay, as in the Run view — with
// the same idempotent live-preview deploy the embedded grid uses.
import { useMemo } from 'react'
import type { CaptureRuntime } from '@twasta/page-runtime/txn/capture'
import { makeDesignerCaptureRuntime } from '@/livepreview/captureRuntime'
import { ensureDeployed } from '@/pages/designers/page/EmbedCaptureTabularPreview'

export function makePlatformImportRuntime(project: string): CaptureRuntime {
  return makeDesignerCaptureRuntime(project, ensureDeployed, 'customize')
}

export function usePlatformImportRuntime(project: string): CaptureRuntime {
  return useMemo(() => makePlatformImportRuntime(project), [project])
}
